import * as React from 'react';
export const pixSvg = React.forwardRef(function pixSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#32BCAD',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M9.572 9.627c.942 0 1.827.366 2.493 1.032l3.613 3.614a.67.67 0 0 0 .946 0l3.6-3.6a3.504 3.504 0 0 1 2.493-1.033h.433l-4.571-4.572a3.645 3.645 0 0 0-5.157 0l-4.56 4.559h.71ZM22.717 22.36a3.503 3.503 0 0 1-2.493-1.032l-3.6-3.6a.684.684 0 0 0-.946 0l-3.613 3.613a3.503 3.503 0 0 1-2.493 1.032h-.709l4.559 4.56a3.646 3.646 0 0 0 5.156 0l4.573-4.573h-.434Z',
      fill: '#fff',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'm24.169 10.659 2.763 2.763a3.646 3.646 0 0 1 0 5.156L24.17 21.34a.525.525 0 0 0-.196-.039h-1.256a2.483 2.483 0 0 1-1.744-.723l-3.6-3.6c-.653-.653-1.79-.653-2.444 0l-3.613 3.613a2.483 2.483 0 0 1-1.745.723H8.028a.526.526 0 0 0-.185.037l-2.774-2.774a3.646 3.646 0 0 1 0-5.156l2.774-2.774c.058.022.12.037.185.037h1.545c.65 0 1.285.264 1.745.723l3.613 3.613a1.723 1.723 0 0 0 1.883.374c.21-.087.4-.214.56-.375l3.6-3.6c.464-.46 1.09-.72 1.744-.722h1.256a.52.52 0 0 0 .195-.04Z',
      fill: '#fff',
    }),
  );
});
pixSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var pix = {
  category: 'brand',
  colorable: false,
  name: 'pix',
  svg: pixSvg,
};
